import gsap from 'gsap';

const transition_staggered_fade = {
    methods: {
        beforeEnter: function(el) {
            el.style.opacity = 0;
            el.style.transform = 'scaleX(0) scaleY(0)';
        },
        enter: function(el, done) {
            const delay = Math.log(el.dataset.index + 2) / 4;
            gsap.to(el, 0.5, {
                opacity: 1,
                scaleX: 1,
                scaleY: 1,
                onComplete: done,
                delay: delay
            });
        },
        leave: function(el, done) {
            el.style.opacity = 0;
            el.style.transform = 'scaleX(0) scaleY(0)';
            done();
        }
    }
};

export default transition_staggered_fade;
